import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { EmojiPickerComponent } from './EmojiPicker.Component';

@NgModule({
	declarations: [EmojiPickerComponent],
	exports: [EmojiPickerComponent],
	imports: [
		CommonModule,
		FormsModule,
		BsDropdownModule,
		TooltipModule,
		TranslateModule
	]
})
export class EmojiPickerModule {}
